module.exports = __webpack_public_path__ + "img/r-145.db461e84.jpg";